const SliderImgs = [
    { 
        DesktopImg: require("../Assets/images/Landing/1.avif"),
        MobileImg: require("../Assets/images/Landing/1-T.jpg"),
    },
    
    { 
        DesktopImg: require("../Assets/images/Landing/2.avif"),
        MobileImg: require("../Assets/images/Landing/2-T.jpg"),
    },

    { 
        DesktopImg: require("../Assets/images/Landing/3.avif"),
        MobileImg: require("../Assets/images/Landing/3-T.jpg"),
    },
];

export default SliderImgs;



